import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import getRulesMailingList from "../../../api/services/getRulesMailingList";
import { FormAutocomplete } from "../../../components/fields";
import { ReactQueryKey } from "../../../types";
import { IFormValuesRule } from "../types";

const MailingList = () => {

    const { t } = useTranslation('booking');

    const mailingListQuery = useQuery(
        [ReactQueryKey.RulesMailingList],
        getRulesMailingList
    );

    return (
        <FormAutocomplete<IFormValuesRule>
            name="mailingList"
            label={t('label.mailingList')}
            options={mailingListQuery.data?.mailingList ?? []}
            loading={mailingListQuery.isLoading}
            multiple
            freeSolo
            blurOnSelect={false}
        />
    );
};

export default MailingList;